import { apiClient } from '@/shared/api/client';

export interface InboxNotification {
  notificationId: number;
  clientCd: string;
  userId: string;
  eventType: string;
  eventTypeName?: string | null;
  category?: string | null;
  priority?: string | null;
  title: string;
  body?: string | null;
  linkUrl?: string | null;
  refModule?: string | null;
  refId?: string | null;
  isRead: string;
  readAt?: string | null;
  sysregdate?: string;
}

export async function fetchNotifications(limit = 30, unreadOnly = false) {
  const response = await apiClient.get<{ items: InboxNotification[]; unreadCount: number }>(
    '/notifications',
    { params: { limit, unreadOnly: unreadOnly ? '1' : '0' } }
  );
  return response.data ?? { items: [], unreadCount: 0 };
}

export async function fetchUnreadCount() {
  const response = await apiClient.get<{ unreadCount: number }>('/notifications/unread-count');
  return response.data?.unreadCount ?? 0;
}

export async function markNotificationRead(notificationId: number) {
  const response = await apiClient.patch<{ unreadCount: number }>(
    `/notifications/${notificationId}/read`
  );
  return response.data?.unreadCount ?? 0;
}

export async function markAllNotificationsRead() {
  const response = await apiClient.post<{ unreadCount: number }>('/notifications/read-all');
  return response.data?.unreadCount ?? 0;
}

/** 개발 환경 전용 — 샘플 알림 3건 생성 */
export async function seedTestNotifications(all = true) {
  const response = await apiClient.post<{
    created: { notificationId: number }[];
    unreadCount: number;
  }>('/notifications/test-seed', { all });
  return response.data ?? { created: [], unreadCount: 0 };
}
